import ajax from '@/utils/ajax';

export const head = '/web';

// 秒杀活动
export const reqSeconDkill = (data, endPoint, platform) => ajax(
  `${head}/v1/product/promotion/secKill?endPoint=${endPoint}&platform=${platform}`,
  data,
  'POST',
);
// 秒杀活动 end

// 增加次数接口
export const reqAnnexNum = (annexId, annexType, attributeId, id) => ajax(
  `${head}/v1/lottery/annex/number?annexId=${annexId}&annexType=${annexType}&attributeId=${attributeId}&luckDrawId=${id}`,
);

//  是否达到参与上限接口
export const reqAnnexCap = (annexId, annexType, luckDrawId) => ajax(
  `${head}/v1/lottery/annex/cap?annexId=${annexId}&annexType=${annexType}&luckDrawId=${luckDrawId}`,
);

// 挖矿相关--是否完成浏览任务
export const reqBrowseMining = (data) => ajax(
  `${head}/v1/mining/task/done`,
  data,
  'POST',
);

//设置可玩
export const whetherPlay = (whetherPlay) => ajax(
  `${head}/contact-thing/config-whether-play?whetherPlay=${whetherPlay}`,
);
// 挖矿相关--是否完成浏览任务
export const reqBrowsedoneOne = (data) => ajax(
  `${head}/v1/mining/task/done-one`,
  data,
  'POST',
);


// 挖矿相关--是否完成浏览任务(抽签)
export const reqChouqiandone = (data) => ajax(
  `${head}/v1/mining/task/done`,
  data,
  'POST',
);

//设置可玩
export const againplay = (data) => ajax(
  `${head}/v1/contact-thing/config-whether-play?whetherPlay=${data.whetherPlay}&titleType=${data.titleType}`,
);

//单品促销活动中的所有分类列表接口
export const getTypeaAllApi = () => ajax(`${head}/v1/promotion-list/single-type-all`, '', 'GET');
//单品分类促销列表接口
export const getTypePromotionApi = (data) => ajax(`${head}/v1/promotion-list/single-type-promotion?promotionTypeId=${data.promotionTypeId}&status=${data.status}&pageNum=${data.pageNum}&pageSize=${data.pageSize}&endPoint=${data.endPoint}`, '', 'GET');

//截图游戏增加浏览次数

export const monographicnum = (type) => ajax(
  `${head}/v1/monographic/game/add-num/${type}`,'','POST',
);

//翻卡-获取用户任务信息
export const reqUsertaskUrl = () => ajax(`${head}/v1/flip/user-task`, '', 'GET');
//用户翻牌
export const reqFlipActionUrl = (data) => ajax(`${head}/v1/flip/user-action?letter=${data.letter}&location=${data.location}`,'','POST',);
//获取翻牌活动用户信息
export const reqFlipUserInfoUrl = () => ajax(`${head}/v1/flip/user-info`, '', 'GET');
//用户翻牌单词校验
export const reqWordverifyUrl = (data) => ajax(`${head}/v1/flip/user/word-verify?recordId=${data.recordId}&word=${data.word}`,'','POST',);
//查询用户翻牌中奖记录
export const reqRecordUrl = () => ajax(`${head}/v1/flip/prize/user-record`, '', 'GET');
//获取用户翻牌奖品地址信息
export const reqAddressUrl = () => ajax(`${head}/v1/flip/user/address`, '', 'GET');

//添加用户翻牌奖品地址
export const reqAdddDressUrl = (data) => ajax(`${head}/v1/flip/user/add-address`, data, 'PUT');
//抽卡完成任务接口
export const reqFlipDoneTaskUrl = (type) => ajax(`${head}/v1/flip/user-task/done-task?type=${type}`,'','POST');
